export default "__VITE_ASSET__80221b92__"